import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, } from '@angular/common/http';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { AppState } from '../app.reducer';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class JWTInterceptor implements HttpInterceptor {

  private authToken: string;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private store: Store<AppState>
  ) {
    this.store.select('user')
      .pipe(
        untilDestroyed(this)
      )
      .subscribe(userState => {
        this.authToken = userState.authToken;
      });
  }

  static addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    return req.clone({setHeaders: {Authorization: `Bearer ${token}`}});
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!req.url.includes('static-maps.yandex.ru') && req.url.indexOf('api/signal') === -1) {
      if (this.authToken) {
        req = JWTInterceptor.addToken(req, this.authToken);
      }
    }

    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
          const body = event.body;

          if (body.hasOwnProperty('jsonrpc') && body.jsonrpc === '2.0') {
            if (body.hasOwnProperty('error') && body.error.code === -32600) {
              // return this.handleUnauthorized(req, next);
            }
          }

        }
        return event;
      })
    );
  }
}
